import { RouteConfig } from 'vue-router'
const IndexMetaSVS2025 = () => import('./metasvs-2025/Index.vue')
const ShareMetaSVS2025 = () => import('./metasvs-2025/DouyinSharePage.vue')
const P1RankingMetaSVS2025 = () => import('./metasvs-2025/P1Ranking.vue')
const RewardsMetaSVS2025 = () => import('./metasvs-2025/Rewards.vue')
const InviteMetaSVS2025 = () => import('./metasvs-2025/InviteFriendPage.vue')
const PhysicalRewardSizeEditMetaSVS2025 = () => import('./metasvs-2025/PhysicalRewardSizeEdit.vue')

export const indexMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025',
  name: 'activity_jumprope_match_metasvs_2025',
  component: IndexMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2025 MetaSVS上海虚拟体育公开赛',
  },
}

export const rewardsMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025/rewards',
  name: 'activity_jumprope_match_metasvs_2025_rewards',
  component: RewardsMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}
export const inviteMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025/invite',
  name: 'activity_jumprope_match_metasvs_2025_invite',
  component: InviteMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '邀请好友',
  },
}

export const shareMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025/share',
  name: 'activity_jumprope_match_metasvs_2025_share',
  component: ShareMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抖音分享',
  },
}
export const p1RankingMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025/p1-ranking',
  name: 'activity_jumprope_match_metasvs_2025_p1_ranking',
  component: P1RankingMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '榜单',
  },
}

export const physicalRewardSizeEditMetaSVS2025Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2025/physical-reward-size-edit',
  name: 'activity_jumprope_match_metasvs_2025_physical_reward_size_edit',
  component: PhysicalRewardSizeEditMetaSVS2025,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '尺码选择',
  },
}

export default [
  indexMetaSVS2025Route,
  inviteMetaSVS2025Route,
  rewardsMetaSVS2025Route,
  p1RankingMetaSVS2025Route,
  shareMetaSVS2025Route,
  physicalRewardSizeEditMetaSVS2025Route,
]
